enum WritingDirection {
  LTR,
  RTL,
}

export default WritingDirection;
